import { apiRequest } from './apiClient';

export async function loadOrganization({ rootProfileId, depth = 1, status = 'any', signal }) {
  const items = [];
  const seenIds = new Set();
  const seenCursors = new Set();
  let cursor = null;
  do {
    const params = new URLSearchParams({
      rootProfileId: String(rootProfileId),
      depth: String(depth),
      status,
      limit: '100'
    });
    if (cursor) params.set('cursor', cursor);
    // eslint-disable-next-line no-await-in-loop
    const data = await apiRequest(`/api/workforce/organization?${params.toString()}`, { signal });
    for (const item of Array.isArray(data?.items) ? data.items : []) {
      if (!seenIds.has(item?.id)) {
        seenIds.add(item.id);
        items.push(item);
      }
    }
    const nextCursor = data?.nextCursor || null;
    if (nextCursor && seenCursors.has(nextCursor)) {
      throw new Error('Unable to load organization records because pagination repeated a cursor.');
    }
    if (nextCursor) seenCursors.add(nextCursor);
    cursor = nextCursor;
  } while (cursor && !signal.aborted);
  return items;
}
